<template>
  <!-- ユーザ管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>休暇申請</span>
        <span class="card-header-actions">
          <!-- 登録画面へ遷移するボタン -->
          <router-link :to="{ name: paidAndSudstituteRegister }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li class="preika-form-message" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <!-- 0件は失敗ではないので、赤字の欄（errors）ではなく案内の字で出す。 -->
      <p v-if="emptyNote" class="text-muted">{{ emptyNote }}</p>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" class="title">ステータス</th>
              <th scope="col" class="title">申請日</th>
              <th scope="col" class="title">種別</th>
              <th scope="col" class="title">開始日</th>
              <th scope="col" class="title">終了日</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td :style="statusColor(item.status)" nowrap>{{ item.status }}</td>
              <!-- 申請日は申請した日時。未申請なら空欄（前は最後に保存した日。束5）。 -->
              <td>{{ formatDate(item.submission_at) }}</td>
              <td>
                <router-link
                  :to="{ name: paidAndSudstituteInfo, params: { id: item.id } }"
                  >{{ item.type }}</router-link
                >
              </td>
              <td>{{ formatDate(item.start_day) }}【{{ item.start_time }}】</td>
              <td>
                {{ (item.end_day!=null && item.end_time!=null &&(item.start_day !== item.end_day || item.start_time !== item.end_time)) ? formatDate(item.end_day)+"【"+item.end_time+"】"  : '単日取得' }}
              </td>
              <td>
                <save-button
                  v-if="leaveIsEditable(item.status)"
                  :label="'削除'"
                  :loading="loading"
                  @click="deletePaidAndSubstitute(item.id)"
                  class="btn btn-danger"
                />
                <span v-else class="preika-leave-cancel-guide text-muted">{{ leaveCancelGuide(item.status) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-page="currentPage"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from "./../../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import { backendErrorMessage } from '../../utils/rosterActualPolicy';
import axios from "axios";
import VPagination from "vuejs-paginate";
import SaveButton from '../../common/SaveButton';
import { leaveCancelGuide, leaveIsEditable } from './leaveCancelGuide';
import { leaveTypeName } from '../../utils/leaveTypeName';
export default {
  name: "List",
  components: {
    VPagination,
    SaveButton,
  },
  data() {
    return {
      showModal: false,
      postItem: "",
      items: [],
      employee_id: [],
      deleted_flg: [],
      authority: [],
      errors: [],
      // 0件のときの案内（失敗ではないので errors には入れない）
      emptyNote: '',
      paidAndSudstituteRegister: "",
      paidAndSudstituteInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.paidAndSudstituteRegister = ConstList.ROUTE_PAIDANDSUDSTITUTE_REGISTER;
    this.paidAndSudstituteInfo = ConstList.ROUTE_PAIDANDSUDSTITUTE_INFO;
  },

  computed: {
    // 算出 getter 関数
    time: function () {
      // `this` は vm インスタンスを指します
      return this.message.split("").reverse().join("");
    },
  },

  methods: {
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      {
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/paidandsubstitute", {
            params: {
              currentPage: this.currentPage,
              pageSize: this.pageSize,
            },
          })
          .then((response) => {
            this.items = response.data;
            this.emptyNote = this.items.length === 0 ? ConstList.EMPTY : '';
            this.items.forEach((element) => {
              // 種別を文字列変換（詳細と同じ対応を使う）
              element.type = leaveTypeName(element.type) || element.type

              if (element.start_time === 1) {
                element.start_time = "終日";
              } else if (element.start_time === 2) {
                element.start_time = "午前";
              } else if (element.start_time === 3) {
                element.start_time = "午後";
              }

              if (element.end_time === 1) {
                element.end_time = "終日";
              } else if (element.end_time === 2) {
                element.end_time = "午前";
              } else if (element.end_time === 3) {
                element.end_time = "午後";
              }
              element.updated_at = element.updated_at.slice(0, 10);
            });
          })
          .catch((error) => {
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(requestFailureMessage(error));
            })
            .catch(() => {
              alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
            });
          });
      }
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/paidandsubstitute/count", {
          params: {
            year: this.year,
            month: this.month,
          },
        })
        .then((response) => {
          const totalCount = response.data;
          // 0件でもページャを消さない。切り上げただけだと 0 ページになり、ページャごと消える。
          this.totalPages = Math.max(1, Math.ceil(totalCount / this.pageSize));
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },

    // モーダルを表示
    openModal: function (item, index) {
      this.postItem = item;
      this.postItem.authority_id = this.authority[index];
      this.showModal = true;
    },

    // 有給代休申請を削除
    deletePaidAndSubstitute: function (id) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      if (confirm("削除してもよろしいですか？")) {
        //フラグがfalseならば、フラグをtrueにしたうえでsubmit
        this.loading = true;
        this.submit_flg = true;
        const params = new URLSearchParams();
        params.append("id", id);
        axios
          .post(
            process.env.VUE_APP_API_ORIGIN + "/paidandsubstituteDelete",
            params
          )
          .then(() => {
            this.submit_flg = false;
            this.$store.commit('set', ['sidebarBadgeRefreshTick', Date.now()]);
            alert(ConstList.DELETE_MESSAGE);
            this.showModal = false;
            window.location.reload();
          })
          .catch((error) => {
            this.submit_flg = false;
            /*
             * **サーバが返した理由をそのまま出す。**
             *
             * 承認待ち・承認済みの休暇申請は削除できない。サーバは 409 で
             * 「承認済みの休暇申請は削除できません。」と理由を返している。
             * それを「システムエラー」へ置き換えると、**利用者には
             * なぜ消せないのかが分からない。**しかもこのボタンは
             * 状態に関係なく出ているので、押せるのに通らないだけになる。
             */
            const status = error && error.response ? Number(error.response.status) : 0;
            const message = backendErrorMessage(
              error,
              status ? ConstList.SYSTEM_ERROR : ConstList.SYSTEM_COMMUNICATION_ERROR
            );
            alert(message);
            // 断られた理由が状態のずれなら、画面を読み直して最新にする。
            if (status === 409) window.location.reload();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },
    leaveIsEditable,
    leaveCancelGuide,
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },
};
</script>

<style scoped>
th,
td {
  white-space: nowrap;
}
td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
/*
 * 取り消し方の1行。長いので、この欄だけ折り返す。
 *
 * 幅の上限は付けない（前は 28em＝336px で、列が 477px あるのに手前で折り返していた）。
 * 欄の幅いっぱいを使い、折り返すのは読点・かっこ・「・」の所だけにする
 * （前は「編集・削／除ができます。」と語の途中で切れていた）。
 * どうしても入らない幅のときだけ、はみ出さないよう途中で折る。
 */
.preika-leave-cancel-guide {
  display: block;
  min-width: 16em;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.5;
}
</style>
